/**
 * Labstep
 *
 * @module components/NotificationAlert/Form/ShowEdit/MinutesBefore
 * @desc Message show edit for notification alert
 */

import { fieldNotificationAlertMinutesBefore } from 'labstep-web/components/NotificationAlert/Form/fields';
import { FormShowEditText as ShowEditText } from 'labstep-web/core/Form/ShowEdit/Text';
import type React from 'react';
import type { NotificationAlertFormShowEditMinutesBeforeProps } from './types';

export const NotificationAlertFormShowEditMinutesBefore: React.FC<
  NotificationAlertFormShowEditMinutesBeforeProps
> = ({ notificationAlert, ...rest }) => (
  <ShowEditText
    entityName={notificationAlert.entityName}
    entity={notificationAlert}
    field={fieldNotificationAlertMinutesBefore}
    {...rest}
  >
    {notificationAlert.minutes_before}
  </ShowEditText>
);
